import { isArray } from 'lodash';
import Vue from 'vue';

const state = () => ({
  retData: null,
  // items: {
  //   articles: {
  //     prevence: {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 3,
  //             author: null,
  //             title: 'Dolorem vero est.',
  //             perex:
  //               'Et voluptatem at sit veniam ut est. Quidem corporis perspiciatis eos expedita autem. Nihil quae qui eum laboriosam officia non. Ut ut dolor est quidem. Tempora quis ea impedit.',
  //             createdAt: '2023-08-22T08:44:11+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ]
  //       ]
  //     },
  //     test: { itemsPerPage: 4, pages: [[]] },
  //     'test-test': { itemsPerPage: 4, pages: [[]] },
  //     'test-test-test-test': { itemsPerPage: 4, pages: [[]] },
  //     'zdravotni-tip': {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 1,
  //             author: null,
  //             title: 'Sequi quasi commodi.',
  //             perex:
  //               'Laborum cum doloribus quaerat eligendi et eos fuga quo. Tenetur totam repellendus mollitia. Omnis repudiandae nulla accusantium ea.',
  //             createdAt: '2023-08-22T08:44:10+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ]
  //       ]
  //     },
  //     'test-test-test': { itemsPerPage: 4, pages: [[]] },
  //     'klientska-zona': {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 9,
  //             author: null,
  //             title: 'Veniam tempora voluptas ratione aliquam.',
  //             perex:
  //               'Dignissimos doloremque ipsa laudantium velit. Quisquam dolores placeat nesciunt quae praesentium tempora. Minus vel quis odio mollitia reprehenderit vero officiis.',
  //             createdAt: '2023-08-22T08:44:14+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 10,
  //             author: null,
  //             title: 'Et provident molestiae.',
  //             perex:
  //               'Sed fugit et in ut et at pariatur. Ea harum fuga perferendis molestias perferendis. Quaerat sed et animi. Dolores nam magni blanditiis et temporibus.',
  //             createdAt: '2023-08-22T08:44:14+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 7,
  //             author: null,
  //             title: 'Et consectetur voluptas recusandae.',
  //             perex:
  //               'Est debitis beatae totam unde ut. Est repellat reprehenderit debitis sed libero vel. Est quis non odit adipisci tenetur adipisci. Autem qui sequi voluptatem et dignissimos eum.',
  //             createdAt: '2023-08-22T08:44:13+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 8,
  //             author: null,
  //             title: 'Et provident consectetur libero molestiae.',
  //             perex:
  //               'Esse et delectus est. Eaque aut et ut explicabo sit blanditiis dicta. Tempore suscipit perferendis vitae veniam et. Eum sed itaque dolore maxime.',
  //             createdAt: '2023-08-22T08:44:13+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ],
  //         [
  //           {
  //             id: 4,
  //             author: null,
  //             title: 'Sint possimus occaecati.',
  //             perex:
  //               'Est et et sed laborum id facilis. Rem ad accusamus laudantium quia eaque. Aut recusandae aut doloribus quia.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 5,
  //             author: null,
  //             title: 'Ut quia eos.',
  //             perex:
  //               'Officia sed tempore ducimus unde. Ratione voluptas nulla ex sit nemo tempore reprehenderit. Et officia unde enim.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 6,
  //             author: null,
  //             title: 'Quia aspernatur et.',
  //             perex:
  //               'Impedit animi omnis repellat modi sit. Molestiae eveniet magni eum omnis et. Nesciunt commodi neque magni quibusdam omnis nam.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           },
  //           {
  //             id: 3,
  //             author: null,
  //             title: 'Dolorem vero est.',
  //             perex:
  //               'Et voluptatem at sit veniam ut est. Quidem corporis perspiciatis eos expedita autem. Nihil quae qui eum laboriosam officia non. Ut ut dolor est quidem. Tempora quis ea impedit.',
  //             createdAt: '2023-08-22T08:44:11+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ],
  //         null
  //       ]
  //     }
  //   },
  //   consultations: {
  //     prevence: {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 3,
  //             author: null,
  //             title: 'Dolorem vero est.',
  //             perex:
  //               'Et voluptatem at sit veniam ut est. Quidem corporis perspiciatis eos expedita autem. Nihil quae qui eum laboriosam officia non. Ut ut dolor est quidem. Tempora quis ea impedit.',
  //             createdAt: '2023-08-22T08:44:11+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ]
  //       ]
  //     },
  //     test: { itemsPerPage: 4, pages: [[]] },
  //     'test-test': { itemsPerPage: 4, pages: [[]] },
  //     'test-test-test-test': { itemsPerPage: 4, pages: [[]] },
  //     'zdravotni-tip': {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 1,
  //             author: null,
  //             title: 'Sequi quasi commodi.',
  //             perex:
  //               'Laborum cum doloribus quaerat eligendi et eos fuga quo. Tenetur totam repellendus mollitia. Omnis repudiandae nulla accusantium ea.',
  //             createdAt: '2023-08-22T08:44:10+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023'
  //           }
  //         ]
  //       ]
  //     },
  //     'test-test-test': { itemsPerPage: 4, pages: [[]] },
  //     problem: {
  //       itemsPerPage: 4,
  //       pages: [
  //         [
  //           {
  //             id: 9,
  //             author: 'autor',
  //             title: 'Veniam tempora voluptas ratione aliquam gakojais vkoasbj oaksvij soklAOKG?',
  //             content:
  //               'Dignissimos doloremque ipsa laudantium velit. Quisquam dolores placeat nesciunt quae praesentium tempora. Minus vel quis odio mollitia reprehenderit vero officiis.',
  //             createdAt: '2023-08-22T08:44:14+00:00',
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content:
  //                   'odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 odpověď 1 ',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           },
  //           {
  //             id: 10,
  //             author: null,
  //             title: 'Et provident molestiae.',
  //             content:
  //               'Sed fugit et in ut et at pariatur. Ea harum fuga perferendis molestias perferendis. Quaerat sed et animi. Dolores nam magni blanditiis et temporibus.',
  //             createdAt: '2023-08-22T08:44:14+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               },
  //               {
  //                 author: 'doktor 2',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 2',
  //                 specialization: 'specializace 2',
  //                 organization: 'organizace 2'
  //               }
  //             ]
  //           },
  //           {
  //             id: 7,
  //             author: null,
  //             title: 'Et consectetur voluptas recusandae.',
  //             content:
  //               'Est debitis beatae totam unde ut. Est repellat reprehenderit debitis sed libero vel. Est quis non odit adipisci tenetur adipisci. Autem qui sequi voluptatem et dignissimos eum.',
  //             createdAt: '2023-08-22T08:44:13+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           },
  //           {
  //             id: 8,
  //             author: null,
  //             title: 'Et provident consectetur libero molestiae.',
  //             content:
  //               'Esse et delectus est. Eaque aut et ut explicabo sit blanditiis dicta. Tempore suscipit perferendis vitae veniam et. Eum sed itaque dolore maxime.',
  //             createdAt: '2023-08-22T08:44:13+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           }
  //         ],
  //         [
  //           {
  //             id: 4,
  //             author: null,
  //             title: 'Sint possimus occaecati.',
  //             content:
  //               'Est et et sed laborum id facilis. Rem ad accusamus laudantium quia eaque. Aut recusandae aut doloribus quia.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           },
  //           {
  //             id: 5,
  //             author: null,
  //             title: 'Ut quia eos.',
  //             content:
  //               'Officia sed tempore ducimus unde. Ratione voluptas nulla ex sit nemo tempore reprehenderit. Et officia unde enim.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           },
  //           {
  //             id: 6,
  //             author: null,
  //             title: 'Quia aspernatur et.',
  //             content:
  //               'Impedit animi omnis repellat modi sit. Molestiae eveniet magni eum omnis et. Nesciunt commodi neque magni quibusdam omnis nam.',
  //             createdAt: '2023-08-22T08:44:12+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           },
  //           {
  //             id: 3,
  //             author: null,
  //             title: 'Dolorem vero est.',
  //             content:
  //               'Et voluptatem at sit veniam ut est. Quidem corporis perspiciatis eos expedita autem. Nihil quae qui eum laboriosam officia non. Ut ut dolor est quidem. Tempora quis ea impedit.',
  //             createdAt: '2023-08-22T08:44:11+00:00',
  //             imageUrl: null,
  //             date: '22.8.2023',
  //             labels: [{ slug: 'slug label' }, { name: 'name label' }],
  //             answers: [
  //               {
  //                 author: 'doktor 1',
  //                 imageUrl:
  //                   'https://images.ulekare.cz/07363dd1-ead3-4dcf-899f-5b0d666e29a0-userImage@1x.png',
  //                 content: 'odpověď 1',
  //                 specialization: 'specializace 1',
  //                 organization: 'organizace 1'
  //               }
  //             ]
  //           }
  //         ]
  //       ]
  //     }
  //   }
  // },
  items: {},
  // tags: [
  //   { name: 'Zdraví je vaše', chip: 'Vše', slug: 'klientska-zona', childNodes: [] },
  //   {
  //     name: 'Prevence',
  //     slug: 'prevence',
  //     childNodes: []
  //   },
  //   { name: 'test', slug: 'test', childNodes: [] },
  //   {
  //     name: 'test test',
  //     slug: 'test-test',
  //     childNodes: []
  //   },
  //   { name: 'test test test', slug: 'test-test-test', childNodes: [] },
  //   {
  //     name: 'test test test test',
  //     slug: 'test-test-test-test',
  //     childNodes: []
  //   },
  //   { name: 'Zdravotní tip', slug: 'zdravotni-tip', childNodes: [] }
  // ]
  tags: {}
});

const getters = {
  retData(state) {
    return state.retData;
  },
  items(state) {
    return state.items;
  },
  tags(state) {
    return state.tags;
  }
};

const mutations = {
  setRetData(state, payload) {
    state.retData = payload;
  },
  setItems(state, payload) {
    Vue.set(state.items, payload.storeKey, payload.items);
  },
  fillItemsPage(state, payload) {
    Vue.set(state.items[payload.storeKey][payload.slug].pages, payload.pageIndex, payload.items);
  },
  resetStore(state) {
    state.items = {};
    state.retData = null;
    state.tags = {};
  },
  setTags(state, payload) {
    Vue.set(state.tags, payload.storeKey, payload.tags);
  }
};

const actions = {
  setRetData({ commit }, payload) {
    commit('setRetData', payload);
  },
  async loadTags({ commit, dispatch }, payload) {
    try {
      const baseURL = import.meta.env.VITE_OLD_WEB_URL || '';
      const data = await this.$http.get(`${baseURL}/api/tags${payload.allTagsUrlSuffix || ''}`);

      let tags = isArray(data) ? [...data] : [...data.childNodes];

      if (payload.allItemsTag) {
        tags.unshift(payload.allItemsTag);
      }

      const uniqueTags = tags.filter((value, index, array) => {
        return array.findIndex(item => item.slug === value.slug) === index;
      });

      commit('setTags', { tags: uniqueTags, storeKey: payload.storeKey });
    } catch (error) {
      dispatch(
        'errorModal/handleError',
        { error, showModal: false, code: '0x0000005C' },
        { root: true }
      );
    }
  },
  async loadItems({ commit, dispatch, state }, payload) {
    const keyedItems = state.items[payload.storeKey];

    try {
      const baseURL = import.meta.env.VITE_OLD_WEB_URL || '';
      const data = await this.$http.get(`${baseURL}/api/${payload.itemsUrl}`);
      if (keyedItems?.[payload.slug]?.pages?.length !== data.pageCount) {
        const newItems = {
          itemsPerPage: payload.itemsPerPage,
          pages: new Array(data.pageCount)
        };

        commit('setItems', {
          items: {
            ...keyedItems,
            [payload.slug]: newItems
          },
          storeKey: payload.storeKey
        });
      }

      commit('fillItemsPage', {
        storeKey: payload.storeKey,
        slug: payload.slug,
        pageIndex: payload.page - 1,
        items: data.items
          .filter(item => !!item)
          .map(item => {
            const createdAt = new Date(item.createdAt);
            return {
              ...item,
              date: createdAt
            };
          })
      });
    } catch (error) {
      dispatch(
        'errorModal/handleError',
        { error, showModal: false, code: '0x0000005D' },
        { root: true }
      );
    }
  }
};

export const explore = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
